import React from 'react';
import type { TeamMember } from '@/lib/types';

interface MemberAvatarProps {
  member?: TeamMember | null;
  name?: string;
  size?: number;
  className?: string;
}

/**
 * Renders a team member avatar:
 *  1. Bitmap image (avatarUrl) if available
 *  2. Colored circle with initials as fallback
 *  3. Empty placeholder if no member found
 */
export const MemberAvatar = React.memo(function MemberAvatar({
  member,
  name,
  size = 32,
  className = '',
}: MemberAvatarProps) {
  const displayName = member?.name || name || '';

  if (member?.avatarUrl) {
    return (
      <img
        src={member.avatarUrl}
        alt={displayName}
        className={`avatar flex-none member-avatar-img ${className}`}
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <div
      className={`avatar avatar-placeholder flex-none ${className}`}
      style={{ width: size, height: size }}
      title={displayName}
    />
  );
});
